import { createClient } from "@formium/client";
import React, { useState } from "react";

import "./Contact.css";
function Contact() {
	const [name,setName] = useState("");
	const [email,setEmail] = useState("");
	const [msg,setMsg] = useState("");
	const [submitting,setSubmitting] = useState(false);
	const [submitSucces,setSubmitSucess] = useState(false);
	const [submitError,setSubmitError ] = useState(false);
	// eslint-disable-next-line no-undef
	const formium = createClient(process.env.REACT_APP_PROJECTID);
	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitting(true);
		const data = new FormData();
		data.append("name",name);
		data.append("email",email);
		data.append("message",msg);
		formium.submitForm("hire-me",data)
			.then(res => {
				if(res.ok){
					setSubmitting(false);
					setSubmitSucess(true);
				}
				if(!res.ok){
					setSubmitSucess(false);
					setSubmitting(false);
					setSubmitError(true);
				}
			}
			);
	};
 
	return (
		<div className=" contact_div card bg-dark text-white mx-auto  p-3 ">
			<div className="card-body">
				<h3 className="text-center m-2">Get in touch </h3>
				<form
					onSubmit={handleSubmit}
				>
					<div className="form-group">
						<input
							name="name"
							className="form-control"
							placeholder="your name"
							onChange={(e) => setName(e.target.value) }
							required
						/>
					</div>
					<div className="form-group">
						<input
							name="email"
							className="form-control"
							col="3"
							placeholder="your email"
							onChange={(e) => setEmail(e.target.value) }

							required
						/>
					</div>
					<div className="form-group">
						<textarea
							name="message"
							className="form-control"
							placeholder="your message"
							onChange={(e) => setMsg(e.target.value) }

							rows="3"
							required
						></textarea>
					</div>

					<p className="text-white text-block ">
            Sending email to fahimalif077@gmail.com
					</p>
					{/* {serverState.status && (
            <p className={!serverState.status.ok ? "errorMsg" : ""}>
              <h2>{serverState.status.msg}</h2>
            </p>
          )} */}
					{
						submitSucces &&     <h2>Thanks for messaging,I will reply to you as soon as I can.</h2>
					}
					{
						submitError && <h2>OOps! Something went wrong</h2>
					}
					<button
						className="btn btn-success btn-block"
						type="submit"
						disabled={submitting}
					>
            Send Message
					</button>
				</form>
			</div>
		</div>
	);
}

export default Contact;
